import * as api from '@/http'

export const ActionSetAcquisitions = async ({ commit }) => {
  const acquisitions = await api.http.get('dash/acquisitions').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_acquisitions', acquisitions)
}

export const ActionSetAcquisitionTypes = async ({ commit }) => {
  const types = await api.http.get('dash/acquisitions/types').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_acquisitionTypes', types)
}

export const ActionSetAcquisitionCategories = async ({ commit }) => {
  const categories = await api.http.get('dash/acquisitions/categories').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_acquisitionCategories', categories)
}

export const ActionSetAcquisitionSources = async ({ commit }) => {
  const sources = await api.http.get('dash/acquisitions/sources').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_acquisitionSources', sources)
}

export const ActionStoreAcquisition = async ({ commit }, data) => {
  const acquisition = await api.http
    .post('dash/acquisitions', data)
    .then((response) => response.body)
  commit('SET_acquisitions', acquisition)
}

export const ActionUpdateAcquisition = async ({ commit }, payload) => {
  const acquisition = await api.http
    .post(`dash/acquisitions/${payload.id}`, payload.form_data)
    .then((response) => response.body)
  commit('SET_acquisitions', acquisition)
}

export const ActionDeleteAcquisition = async ({ commit }, payload) => {
  const acquisition = await api.http
    .put(`dash/acquisitions/delete/${payload}`, payload)
    .then((response) => response.body)
  commit('SET_acquisitions', acquisition)
}

// Invoices
export const ActionSetInvoices = async ({ commit }) => {
  const invoice = await api.http.get('dash/invoices').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_invoices', invoice)
}

export const ActionStoreInvoice = async ({ commit, dispatch }, data) => {
  const new_invoice = await api.http.post('dash/invoices', data).then((response) => response.body)
  await dispatch('ActionSetInvoices')
  commit('SET_new_invoice', new_invoice)
}

export const ActionClearNewInvoice = ({ commit }) => {
  commit('SET_new_invoice', [])
}

// invoice items
export const ActionStoreInvoiceItem = async ({ commit }, data) => {
  const new_item = await api.http.post('dash/invoice_items', data).then((response) => response.body)
  commit('SET_invoice_items', new_item)
}

export const ActionSetInvoicesItems = async ({ commit }) => {
  const invoice = await api.http.get('dash/invoice_items').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_invoice_items', invoice)
}

// provider
export const ActionStoreProvider = async ({ commit }, data) => {
  const providers = await api.http.post('dash/provider', data).then((response) => response.body)
  commit('SET_providers', providers)
}

// acquisition category
export const ActionStoreAcquisitionCategory = async ({ commit }, data) => {
  const categories = await api.http
    .post('dash/acquisition_category', data)
    .then((response) => response.body)
  commit('SET_acquisitionCategories', categories)
}
